import classNames from 'classnames';
import * as React from 'react';
import styles from './ProgressBar.module.scss.js';

var ProgressBar = React.memo(function (props) {
    var _a;
    var progressBarStyle = {
        width: props.completed * 100 + '%',
    };
    if (props.color) {
        progressBarStyle.background = props.color;
    }
    var classNameBase = classNames(styles.base, props.className, (_a = {},
        _a[styles.isNavProgress] = props.isNavProgress,
        _a));
    return (React.createElement("div", { className: classNameBase },
        React.createElement("div", { style: progressBarStyle, className: styles[props.size] })));
});

export { ProgressBar as default };
//# sourceMappingURL=ProgressBar.js.map
